import { Component } from '@angular/core';
import { SharedService } from 'app/shared/services/shared.service';
import { GoogleAnalyticsService } from 'app/shared/services/google-analytics.service';

@Component({
  selector: 'flash-messages-component',
  templateUrl: './flash-messages.component.html',
  styleUrls: ['./flash-messages.component.scss'],
})
export class FlashMessagesComponent {
  constructor(public sharedService: SharedService, public ga: GoogleAnalyticsService) {}
}
